import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import { useModal } from "../../hooks/useState"
import { MenuProfile } from "./menu_header";
import { MenuHelp } from "./menu_help";
import gsap from "gsap";

export default function Modal() {
	const { openModal, isOpen } = useModal(state => state)
	
	const timeline = gsap.timeline({
		defaults: {
			ease: 'power1.in',
			duration: 0.35
		}
	})
	
	const showModal = () => {
		let container = document.querySelector(".ar__modal_overlay");
		timeline.to(container, {
			opacity: 1,
			onStart() {
				this.targets()[0].style.display = 'block'
			},
		}, 0)
		
	}
	const hideModal = () => {
		let container = document.querySelector(".ar__modal_overlay");
		timeline.to(container, {
			opacity: 0,
			onComplete() {
				this.targets()[0].style.display = 'none'
			}
		}, 0)
	}
	
	useEffect(() => {
		isOpen ? showModal() : hideModal()
	}, [isOpen]);
	
	return (
		<>
			<section className={`ar__modal_overlay`}>
				{renderModal()}
			</section>
		</>
	)
};

const renderModal = () => {
	const { modal } = useModal(state => state)

	switch (modal) {
		case 'menu_profile':
			return <MenuProfile />;
		case 'help':
			return <MenuHelp />;
		default:
			return <Clear />;
	}
}

const Clear = () => {
	const { closeModal } = useModal(state => state)
	useEffect(() => {
		closeModal()
	}, []) 
	return (<div></div>)
}